import React from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@/components/common/Button';
import { Input } from '@/components/common/Input';
import { Textarea } from '@/components/common/Textarea';

export const InvoiceDetails: React.FC = () => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      companyName: 'Vatsal Patel',
      bankName: '',
      branchName: '',
      accountNumber: '',
      ifscCode: '',
      gstNumber: '',
      email: 'vatsal_patel123@gmail.com',
      phone: '',
      address: '',
      termsAndConditions: 'Some text goes here...',
      logo: null,
    }
  });

  const onSubmit = (data: any) => {
    console.log('Invoice details:', data);
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-medium">Invoice Details</h3>
      </div>
      
      <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-6">
        <div className="grid grid-cols-2 gap-6">
          <div className="col-span-2">
            <h4 className="font-medium mb-4">Company Details</h4>
          </div>
          
          <Input
            label="Company Name"
            {...register('companyName', { required: 'Company name is required' })}
            error={errors.companyName?.message}
          />
          
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Business Logo
            </label>
            <div className="flex items-center space-x-4">
              <div className="w-20 h-20 bg-blue-500 rounded-lg flex items-center justify-center text-white text-2xl font-bold">
                S
              </div>
              <Button type="button" variant="secondary" size="sm">
                Change
              </Button>
              <Button type="button" variant="secondary" size="sm">
                Remove
              </Button>
            </div>
            <p className="text-xs text-gray-500">Recommended size: JPG, PNG | Recommended size: 330x300</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6">
          <div className="col-span-2">
            <h4 className="font-medium mb-4">Bank Details</h4>
          </div>
          
          <Input
            label="Bank Name"
            {...register('bankName')}
          />
          
          <Input
            label="Branch Name"
            {...register('branchName')}
          />
          
          <Input
            label="Account Number"
            {...register('accountNumber')}
          />
          
          <Input
            label="IFSC Code"
            {...register('ifscCode')}
          />
        </div>

        <div className="grid grid-cols-2 gap-6">
          <Input
            label="GST Number"
            {...register('gstNumber')}
          />
          
          <Input
            label="Email Address"
            type="email"
            {...register('email')}
          />
          
          <Input
            label="Phone Number"
            {...register('phone')}
          />
          
          <Input
            label="Address"
            {...register('address')}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Terms & Conditions
          </label>
          <Textarea
            {...register('termsAndConditions')}
            rows={4}
          />
        </div>

        <div className="flex justify-end">
          <Button type="submit" variant="primary">
            Save Changes
          </Button>
        </div>
      </form>
    </div>
  );
};